import React from 'react';
import { Menu, MenuItem, Divider, useTheme } from '@mui/material';
import { Edit as EditIcon, Task as TaskIcon, AttachMoney as MoneyIcon } from '@mui/icons-material';

interface OpportunityMenuProps {
  anchorEl: HTMLElement | null;
  open: boolean;
  onClose: () => void;
}

const OpportunityMenu: React.FC<OpportunityMenuProps> = ({ anchorEl, open, onClose }) => {
  const theme = useTheme();
  
  return (
    <Menu
      anchorEl={anchorEl}
      open={open}
      onClose={onClose}
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'right',
      }}
      transformOrigin={{
        vertical: 'top',
        horizontal: 'right',
      }}
    >
      <MenuItem onClick={onClose}>
        <EditIcon fontSize="small" sx={{ mr: 1 }} />
        Redigera
      </MenuItem>
      <MenuItem onClick={onClose}>
        <TaskIcon fontSize="small" sx={{ mr: 1 }} />
        Lägg till aktivitet
      </MenuItem>
      <MenuItem onClick={onClose}>
        <MoneyIcon fontSize="small" sx={{ mr: 1 }} />
        Lägg till produkt
      </MenuItem>
      <Divider />
      <MenuItem onClick={onClose} sx={{ color: theme.palette.error.main }}>
        Ta bort
      </MenuItem>
    </Menu>
  );
};

export default OpportunityMenu;